import React from "react";
// mui
import { Grid2 } from "@mui/material";
// styling
import styles from "./Reviewpage.module.scss";
// Icons
import { ReactComponent as Blueprint } from "../../../../../../GlobalAssets/svg/Blueprint12.svg";
import { ReactComponent as Clonesite } from "../../../../../../GlobalAssets/svg/clonesite12.svg";
// Local imports
import ReviewField from "../../../../../../GlobalComponents/ReviewField/ReviewField";
import ReviewCard from "../../../../../../GlobalComponents/ReviewCard/ReviewCard";
import {
  selectedTypeData,
  installationTypeData,
  inputFields,
  environmentFields,
  plugins,
} from "../ConstantData/CreateSiteConstantData";

export default function Reviewpage(props) {
  const {
    showType,
    selectedType,
    installationType,
    cloneSite,
    blueprint,
    isInput,
    showEnvironment,
    cloneSiteData,
    pluginCard,
    dedicatedHosting,
  } = props;

  const selectedSiteDetails = selectedTypeData[selectedType];
  const installationTypeDetails = installationTypeData[installationType];
  const cloneSiteDetails = cloneSiteData[cloneSite];

  return (
    <Grid2 className={styles.ReviewpageContainer}>
      <Grid2 className={styles.inputTextBox}>
        {showType && (
          <ReviewCard
            header="Selected Site Type"
            title={showType?.title}
            subTitle={showType?.description}
            icon={showType?.icon}
          />
        )}
        {selectedSiteDetails && (
          <ReviewCard
            header="Selected Site Type"
            title={selectedSiteDetails.title}
            subTitle={selectedSiteDetails.description}
            icon={selectedSiteDetails.icon}
          />
        )}
        {installationTypeDetails && (
          <ReviewCard
            header="Selected Installation Type"
            title={installationTypeDetails.title}
            subTitle={installationTypeDetails.description}
          />
        )}
        {cloneSiteDetails && (
          <ReviewCard
            header="Selected Clone Site"
            title={cloneSiteDetails.title}
            icon={Clonesite}
          />
        )}
        {blueprint && (
          <ReviewCard
            header="Selected Blueprint Site"
            title={blueprint.title}
            icon={Blueprint}
          />
        )}
      </Grid2>
      {pluginCard.length > 0 && (
        <Grid2 className={styles.header}>Selected Recommended Plugin</Grid2>
      )}
      <Grid2 className={styles.inputTextBox}>
        {pluginCard?.map((plugin, index) => {
          const pluginDetails = plugins[plugin.index];
          return (
            <ReviewCard
              key={index}
              header=""
              imageSrc={pluginDetails.imageSrc}
              title={pluginDetails.header}
              subTitle={pluginDetails.subHeader}
            />
          );
        })}
      </Grid2>
      <Grid2 className={styles.inputTextBox}>
        {inputFields(isInput, dedicatedHosting).map((field, index) => (
          <ReviewField
            key={index}
            label={field.label}
            value={field.value}
            suffix={field.suffix}
            showUnderscore={field.showUnderscore}
          />
        ))}
      </Grid2>
      {showEnvironment && (
        <Grid2 className={styles.stgLabel}>Staging Environment Details</Grid2>
      )}
      {showEnvironment && (
        <Grid2 className={styles.inputTextBox}>
          {environmentFields(isInput).map((field, index) => (
            <ReviewField
              key={index}
              label={field.label}
              value={field.value}
              suffix={field.suffix}
              showUnderscore={field.showUnderscore}
            />
          ))}
        </Grid2>
      )}
    </Grid2>
  );
}
